import { Card, CardBody, Col, Row } from "reactstrap";

const PrivacyPolicy = () => {
  return (
    <div className="container public-page-container">
      <Row>
        <Col xs="12" md="10">
          <Card className="card-custom px-md-4 px-s-1">
            <CardBody>
              <iframe
                src="/privacy.html"
                title="Privacy Policy"
                style={{
                  width: "100%",
                  height: "80vh", // 70% of viewport height
                  border: "none",
                  overflow: "auto", // Enables scrolling within the iframe
                }}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PrivacyPolicy;
